import axios from '@/utilities/api/axios';

export const state = initialState();

export const actions = {
  getTemplateForms: async ({ commit, rootState }, payload) => {
    //Access userProfile state
    const { profileId } = rootState.authentication.userProfile.profile;

    try {
      const res = await axios.get(`/template-forms`, {
        params: payload
      });

      const mutatePayload = {
        data: res.data,
        profileId: profileId
      };

      commit('mutateTemplateForms', mutatePayload);
      return res;
    } catch (error) {
      return error.response;
    }
  },

  getTemplateById: async ({ commit }, payload) => {
    try {
      const { templateFormId } = payload;

      const res = await axios.get(
        `/template-forms/${templateFormId}`
      );

      commit('mutateTemplateFormById', res.data);
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  postTemplateForm: async (_, payload) => {
    try {
      const res = await axios.post(
        `/template-forms`,
        payload
      );

      return res;
    } catch (err) {
      console.error(err);
      return;
    }
  },

  updateTemplateForm: async (_, payload) => {
    const { templateFormId, ...theRest } = payload;

    try {
      const res = await axios.put(
        `/template-forms/${templateFormId}`,
        theRest
      );

      return res;
    } catch (err) {
      console.error(err);
      return;
    }
  },

  deleteTemplateForm: async (_, templateFormId) => {
    try {
      const res = await axios.delete(
        `/template-forms/${templateFormId}`
      );

      return res.status;
    } catch (err) {
      console.error(err);
      return;
    }
  },

  addTemplateToFavorites: async (_, payload) => {
    try {
      const { templateFormId, ...body } = payload;

      const res = await axios.put(
        `/template-forms/${templateFormId}/favorites`,
        body
      );

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  removeTemplateFromFavorites: async (_, payload) => {
    try {
      const { templateFormId } = payload;

      const res = await axios.delete(
        `/template-forms/${templateFormId}/favorites`
      );

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  }
};

export const mutations = {
  mutateTemplateForms: (state, payload) => {
    let { data, profileId } = payload;
    let { list, ...everythigElse } = data;

    //Filter templates to only render user's templates and public ones
    list = list.filter(template => {
      const { author, templateForm } = template;
      if (
        author.profileId === profileId ||
        templateForm.status.toLowerCase() === 'public'
      )
        return template;
    });

    data = { list, ...everythigElse };

    state.templateForms = data;
  },

  mutateTemplateFormById: (state, payload) => {
    state.templateFormById = payload;
  }
};

export const getters = {};

function initialState() {
  return {
    templateForms: [],
    templateFormById: {}
  };
}
